class ApplicationActions {
    constructor($applicationStatusButtons) {
        this.$applicationStatusButtons = $applicationStatusButtons;

        if(this.$applicationStatusButtons.length) {
            this.init();
        }
    }

    init() {
        this.$actions = $('.application__extra-action');
        this.$actionsButtons = $('.application__actions .button');

        this.$currentTriggeredAction = null;
        this.$currentTriggeredButton = null;

        if(this.$actions.length && this.$actionsButtons.length) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.onApplicationButtonChangeFn = this.onApplicationButtonChange.bind(this);
        this.onResizeFn = this.onResize.bind(this);

        this.$applicationStatusButtons.on('change', this.onApplicationButtonChangeFn);
        $(window).on('resize', this.onResizeFn);
    }

    onApplicationButtonChange(e) {
        const $target = $(e.target);
        const status = $target.val();
        const $button = $target.parent('.button');
        const $actionsWithStatus = this.$actions.filter(`.application__extra-action--${status}`);
        
        // Reset saved elements
        this.$currentTriggeredAction = null;
        this.$currentTriggeredButton = null;
        // Reset elements positioning
        this.reset();

        // Update action buttons colors
        if($button.length) {
            this.$actionsButtons.not($button).removeClass('button--darkgrey').addClass('button--primary');
            
            if($target.is(':checked')) {
                $button.removeClass('button--primary').addClass('button--darkgrey');
            }
        }

        if($actionsWithStatus.length) {
            this.$currentTriggeredAction = $actionsWithStatus.eq(0);
            this.$currentTriggeredButton = $button;
            
            this.updatePositioning();
        }
    }

    onResize() {
        if(this.$currentTriggeredAction && this.$currentTriggeredButton) {
            this.reset();
            this.updatePositioning();
        }
    }

    updatePositioning() {
        this.$currentTriggeredAction.show();
        this.$currentTriggeredButton.css('margin-bottom', this.$currentTriggeredAction.outerHeight() + 10);

        const windowWidth = window.innerWidth;
        // Current action popup and action button bounding rects
        const buttonRelativeBoundingRect = this.$currentTriggeredButton.position();
        const buttonAbsoluteBoundingRect = this.$currentTriggeredButton.offset();
        const triggeredActionBoundingRect = this.$currentTriggeredAction.offset();
        // Action popup positions
        const topPosition = buttonRelativeBoundingRect.top + this.$currentTriggeredButton.outerHeight();
        let leftPosition = '5%';

        if(windowWidth >= 580 && innerWidth < 1200) {
            leftPosition = '50%';

            if(windowWidth / 2 < buttonAbsoluteBoundingRect.left) {
                this.$currentTriggeredAction.removeClass('application__extra-action--left').addClass('application__extra-action--right');
            }
            else {
                this.$currentTriggeredAction.removeClass('application__extra-action--right').addClass('application__extra-action--left');
            }
        }
        else if(windowWidth >= 1200) {
            if(windowWidth / 2 > buttonAbsoluteBoundingRect.left) {
                leftPosition = buttonRelativeBoundingRect.left;
            }
            else {
                leftPosition = Math.min(buttonRelativeBoundingRect.left - (this.$currentTriggeredAction.outerWidth() - this.$currentTriggeredButton.outerWidth()), 680);
            }
        }

        // Update current action popup positioning
        this.$currentTriggeredAction.css({
            top: topPosition,
            left: leftPosition
        });

        // Update current action popup direction class
        if(windowWidth / 2 < buttonAbsoluteBoundingRect.left) {
            this.$currentTriggeredAction.addClass('application__extra-action--right');
        }
        else {
            this.$currentTriggeredAction.addClass('application__extra-action--left');
        }
    }

    reset() {
        // Hide all actions popups
        this.$actions.hide();
        this.$actions.removeClass('application__extra-action--left application__extra-action--right')
        // Reset all actions popups positioning
        this.$actions.css({
            top: 'auto',
            left: 'auto'
        });
        // Reset all actions button margin
        this.$actionsButtons.css('margin-bottom', 0);
    }
}

export default ApplicationActions;
